import React, { FC } from "react";
import styled from "styled-components";
import { Entry } from "contentful";
import contentfulComponentLoop from "../lib/contentfulComponentLoop";

interface LinkWrapperProps extends Entry {
  id: string,
  fields: {
    openInNewWindow: boolean;
    url: string;
    wrappedComponent: Entry;
  },
  parentProps: {
    isContentInGrid?: boolean;
  }
}

const StyledLink = styled.a`
  text-decoration: none;
`;

const LinkWrapper: FC<LinkWrapperProps> = ({ 
  id, 
  fields: {
    openInNewWindow,
    url,
    wrappedComponent,
  },
  parentProps: {
    isContentInGrid = false
  }
}) => (
  <StyledLink 
    data-component-id={id}
    href={url} 
    target={openInNewWindow ? '_blank' : '_self'} 
  >
    {contentfulComponentLoop([wrappedComponent], {isContentInGrid})}
  </StyledLink>
);

export default LinkWrapper;